import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskAdminTrend, DiskAdminTrendDays } from '../Contracts/DiskAdmin'

/**
 * Тренд зайнятого: `GET /services/disk/admin/trend?days=30|90|365[&storage=]` —
 * нічні знімки й сьогоднішня жива точка. Без `storage` — увесь тенант.
 */
export const LoadDiskAdminTrendTask = async (days: DiskAdminTrendDays, storage?: string): Promise<DiskAdminTrend> =>
    (await restClient.get(
        `${DISK_ADMIN_API}/trend`,
        { searchParams: { days, ...(storage ? { storage } : {}) } },
        { forceRefresh: true }
    )) as unknown as DiskAdminTrend
